import { useNavigate } from 'react-router-dom';

// All books in one flat list for easy scanning. Each can have: name, author, pdfUrl, links[], availableAtMahad.
const BOOKS = [
  {
    name: 'Tafseer Juz Amma - Mubarak',
    author: 'Mubarak Jama Muse',
    pdfUrl: '/Tafseer-Juz-Amma-Mubarak.pdf',
    links: [{ label: 'Amazon', url: 'https://www.amazon.com/dp/B0DG9W11DW' }]
  },
  {
    name: 'Exquisite Pearl',
    author: '',
    pdfUrl: '/Exquisite-Pearl.pdf'
  },
  {
    name: 'Youth Problems',
    author: '',
    pdfUrl: '/Youth-Problems.pdf'
  },
  {
    name: 'Fiqh: A Practical Guide to Worshipping Allah',
    author: 'Haroon Baqai / Faith Publications',
    links: [
      { label: 'Faith Publications', url: 'https://faithpublications.org/product/fiqh-a-practical-guide-to-worshipping-allah/' },
      { label: 'Amazon', url: 'https://www.amazon.com/Fiqh-Practical-Guide-Worshipping-Gratitude/dp/B0D4X2CFHV' },
      { label: 'Barnes & Noble', url: 'https://www.barnesandnoble.com/w/fiqh-haroon-baqai/1145872055?ean=9798987400692' }
    ]
  },
  {
    name: 'The Ultimate Conspectus',
    author: 'Matn al-Ghayat wa al-Taqrib',
    links: [
      { label: 'Zaytuna Bookstore', url: 'https://bookstore.zaytuna.edu/products/the-ultimate-conspectus' },
      { label: 'Mecca Books', url: 'https://www.meccabooks.com/products/the-ultimate-conspectus-matn-al-ghayat-wa-al-taqrib' },
      { label: 'Amazon', url: 'https://a.co/d/faJbWJm' }
    ]
  },
  {
    name: 'Arabic Between Your Hands (with CD), Part 1',
    author: '',
    links: [
      { label: 'Madinah Media', url: 'https://madinahmedia.com/product/arabic-between-your-hands-with-cd-part-1-1' },
      { label: 'Amazon', url: 'https://a.co/d/eaPbBfu' }
    ]
  }
];

export default function TextbooksPage() {
  const navigate = useNavigate();

  return (
    <div className="elegant-font min-h-screen bg-white">
      <header className="sticky top-0 z-30 border-b border-neutral-200 bg-white">
        <div className="max-w-2xl mx-auto px-4 py-3">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate('/')}
              className="p-2 text-neutral-500 hover:text-neutral-900"
              aria-label="Back to home"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
            </button>
            <img src="/logo.jpeg" alt="Abubakar Islamic Institute" className="h-9 w-auto object-contain" />
            <h1 className="text-lg font-semibold text-neutral-900">Textbooks</h1>
          </div>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-6 pb-12">
        <p className="text-sm text-neutral-600 mb-4">
          Required and recommended books for Mahad courses. Some items are only available at the institute.
        </p>

        <a
          href="/Mahad-Textbooks.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium mb-6"
        >
          <svg className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Full list (PDF)
        </a>

        <ul className="space-y-0 border-t border-neutral-200">
          {BOOKS.map((book, index) => (
            <li
              key={index}
              className="border-b border-neutral-100 py-4 first:pt-2"
            >
              <div className="flex flex-col gap-1">
                <span className="font-medium text-neutral-900">{book.name}</span>
                {book.author ? (
                  <span className="text-sm text-neutral-500">{book.author}</span>
                ) : null}
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-1 text-sm">
                  {book.pdfUrl && (
                    <a
                      href={book.pdfUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary-600 hover:text-primary-700 hover:underline"
                    >
                      PDF
                    </a>
                  )}
                  {book.availableAtMahad && (
                    <span className="text-emerald-600">Available at the Mahad</span>
                  )}
                  {book.links?.map((link, i) => (
                    <a
                      key={i}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary-600 hover:text-primary-700 hover:underline"
                    >
                      {link.label}
                    </a>
                  ))}
                </div>
              </div>
            </li>
          ))}
        </ul>

        <p className="text-xs text-neutral-400 mt-8">
          Contact the institute for which books your class uses or for items only at the Mahad.
        </p>
      </main>
    </div>
  );
}
